import Nullstack from 'nullstack';
export default function IconBrandAirtable({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-airtable",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 10v8l7 -3v-2.6z"
  }), "   ", Nullstack.element("path", {
    d: "M3 6l9 3l9 -3l-9 -3z"
  }), "   ", Nullstack.element("path", {
    d: "M14 12.3v8.7l7 -3v-8z"
  }), " ");
}